<div
  *ngIf="config()?.[(value() | columnStatus)] as status"
  [style.border-color]="status.color"
  [style.color]="status.color"
  class="d-flex align-items-center justify-content-center gap-1 p-1 rounded fw-bold text-center s-x-small-bold s-max-w-20"
>
  {{ status.description }}
  <mat-icon *ngIf="status.icon" class="fs-4">
    {{ status.icon }}
  </mat-icon>
</div>
